module.exports = __webpack_public_path__ + "img/9.e6ffff90.png";